import { Button, Modal, Form, OverlayTrigger, Tooltip, Row, Col, Spinner, Tabs, Tab } from 'react-bootstrap'
import { useEffect, useState, useRef } from 'react';
import { RoomContext, AudioTrack  } from '@livekit/components-react';
import { ConnectionState } from "@livekit/components-react";
import { Participant, Room } from 'livekit-client';
import axios from 'axios';

import { Track } from "livekit-client";
import { GridLayout, useTracks, ParticipantTile,VideoConference, AudioConference, useTrackByName, useParticipants, RoomAudioRenderer, AudioVisualizer,BarVisualizer, useVoiceAssistant, ParticipantAudioTile, ParticipantLoop, ParticipantName, TrackLoop, useTrackToggle, TrackToggle, useTranscriptions, LayoutContextProvider, Chat, useConnectionState} from "@livekit/components-react";
import '@livekit/components-styles';
import '../../App.css';

import 'groq-sdk/shims/web';
import Groq from 'groq-sdk';

const groq = new Groq({
  // The SDK automatically uses the GROQ_API_KEY from the environment
  apiKey: process.env.REACT_APP_GROQ_API_KEY, //(for CRA)
  dangerouslyAllowBrowser: true, // Only use this option if you understand the security implications
});

const PauseButton = ({ variant }) => {

    const { buttonProps, enabled } = useTrackToggle({
        source: Track.Source.Microphone,
        initialState: true
    });

    return (
		<></>
        // <Button variant='dark' onClick={buttonProps.onClick} className={`rounded-circle d-flex align-items-center justify-content-center shadow ${variant ? variant : 'pause-btn'}`}>
        //     <i className={`bi ${enabled ? "bi-pause-fill" : "bi-play-fill"}`} />
        // </Button>
    );
};


function MyAudioConference(props) {
   const [widgetState, setWidgetState] = useState({
	   showChat: false,
	   unreadMessages: 0,
	 });
   
	 const audioTracks = useTracks([Track.Source.Microphone]);
	 
	 console.log('Audio Tracks:', audioTracks);
	//  useWarnAboutMissingStyles();
   
	 return (
	   <LayoutContextProvider onWidgetChange={setWidgetState}>
		 {/* <div className="lk-audio-conference" {...props} width="100%"> */}
		   {/* <div className="lk-audio-conference-stage" width="100%"> */}
		   {audioTracks[1] && <ParticipantAudioTile trackRef={audioTracks[1]} width="100%" />}
		   	{/* {audioTracks[0] && <ParticipantAudioTile trackRef={audioTracks[0]} width="50%" />} */}
			 {/* <TrackLoop tracks={audioTracks}>
			   <ParticipantAudioTile width="50%" />
			 </TrackLoop> */}
		   {/* </div> */}
		 {/* </div> */}
	   </LayoutContextProvider>
	 );
}

async function getSummary(conversation) {

	const prompt = `Summarize the following conversation between a user and an agent in a concise manner:\n\n${conversation}\n\nSummary: \n ${conversation}`;
	const chatCompletion = await groq.chat.completions.create({
        messages: [
          {
            role: "user",
            content: prompt,
          },
        ],
        model: "llama-3.1-8b-instant", // Choose a model from the Groq console
      });

      return chatCompletion.choices[0]?.message?.content || ""

}
function ChatBox({ room , summaryText, activeTab, selectedAgent, testprompt, setTestPrompt, testFirstMessage, setTestFirstMessage}) {
    const transcriptions = useTranscriptions();
	const connectionState = useConnectionState(room);
	const [summary, setSummary] = useState(summaryText || '');
	const [localTranscriptions, setLocalTranscriptions] = useState([]);
	const [saving, setSaving] = useState(false);
	

    const boxRef = useRef(null);

	// setTestPrompt(selectedAgent.prompt);
	// setTestFirstMessage(selectedAgent.firstmessage);

    useEffect(() => {
        if (boxRef.current) {
            boxRef.current.scrollTop = boxRef.current.scrollHeight;
        }
		if (transcriptions.length > 0)
		setLocalTranscriptions(transcriptions);
    }, [transcriptions]);

	useEffect(() => {
		const fetchSummary = async () => {
			if (connectionState === 'disconnected'&&localTranscriptions.length>0)
			{
				let conversation=''
				localTranscriptions.forEach((transcription) => {
					const speaker = transcription.participantInfo.identity.includes("agent") ? "Agent" : "User";
					conversation += `${speaker}: ${transcription.text}\n`;
				});
				console.log('Final Conversation:\n', conversation);
				const summary = await getSummary(conversation);
				console.log('Conversation Summary:', summary);
				setSummary(summary);
			}
		}
		fetchSummary();
	}, [connectionState]);

	// Render based on selected tab: 'transcription' or 'summary'
	if (activeTab === 'summary') {
		return (
			<Row style={{ height: '54vh' }}>
				<Col>
					<div className="p-3 m-2 shadow-sm rounded h-100"><strong>Summary:</strong>
						<div className='mt-2'>{summary}</div>
					</div>
				</Col>
			</Row>
		);
	}

	if (activeTab === 'prompt') {
		return (
			<>
					<Row>
						<Col>
					<Form.Group className="mb-3" >
						<Form.Label>Prompt </Form.Label>
						<Form.Control required name='prompt' as="textarea" rows={14} value={testprompt||selectedAgent.prompt} onChange={(e)=>{setTestPrompt(e.target.value)}} />
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col>
					<Form.Group className="mb-3" >
						<Form.Label>First Message</Form.Label>
						<Form.Control name='firstmessage' value={testFirstMessage || selectedAgent.firstmessage} onChange={(e)=>{setTestFirstMessage(e.target.value)}} type="text" />
					</Form.Group>
				</Col>
				
			</Row>
			<Row>
				<Col className="d-flex justify-content-end">
					<Button variant="primary" onClick={async ()=>{
						try{
							setSaving(true);
							const payload = {
								agentid: selectedAgent.id,
								prompt: testprompt || selectedAgent.prompt,
								firstmessage: testFirstMessage || selectedAgent.firstmessage
							};
							const result = await axios.post('/updatevoiceagentprompt', payload);
							if(result && result.data && result.data.ok){
								alert('Saved successfully');
							}else{
								alert('Saved');
							}
						}catch(err){
							console.error(err);
							alert('Failed to save');
						}finally{
							setSaving(false);
						}
					}} disabled={saving}>
						{saving ? 'Saving...' : 'Save'}
					</Button>
				</Col>
			</Row>
			</>
		);
	}

	return (
		<Row style={{ height: '54vh' }}>
			<Col>
				<div className="p-3 m-2 shadow-sm rounded chat-box" ref={boxRef}>
					{localTranscriptions.map((transcription, idx) => (
						<div key={idx}
							style={{
								display: "flex",
								justifyContent: transcription.participantInfo.identity.includes("agent")
									? "flex-start"
									: "flex-end",
								marginBottom: "10px",
							}}
						>
							<div className={`text-start ${transcription.participantInfo.identity.includes("agent") ? "bg-primary" : "bg-light"}`}
								style={{
									maxWidth: "70%",
									padding: "10px 14px",
									borderRadius: "12px",
									color: transcription.participantInfo.identity.includes("agent") ? "#ffffff" : "#333",
									fontSize: "14px",
									lineHeight: "1.4",
								}}
							>
								<strong>
									{transcription.participantInfo.identity.includes("agent") ? "Agent" : "You"}:
								</strong>{" "}
								{transcription.text}
							</div>
						</div>
					))}
				</div>
			</Col>
		</Row>
	);
}

function TestAgentModal(props) {
	const [room] = useState(() => new Room({}));
	const [activeTab, setActiveTab] = useState('transcription');
	// You can manage room connection lifecycle here
	const [loading, setLoading] = useState(false);
	const [isConnected, setIsConnected] = useState(false);
	const [agentName,setAgentName]=useState('');
	const [personName, setPersonName] = useState('');
	const [companyName, setCompanyName] = useState('');
	const [personRole, setPersonRole] = useState('');
	const [summaryText, setSummaryText] = useState('');
	const [testprompt, setTestPrompt] = useState('');
	const [testFirstMessage, setTestFirstMessage] = useState('');
	
	function getRandomInt(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min) + min);
	}

	function replaceDynamicVariables(text) {
		if (!text || typeof text !== 'string') return text;
		const replacements = {
			'[PERSON_NAME]': personName || '',
			'[COMPANY_NAME]': companyName || '',
			'[PERSON_ROLE]': personRole || ''
		};
		return text.replace(/\[PERSON_NAME\]|\[COMPANY_NAME\]|\[PERSON_ROLE\]/g, (match) => replacements[match] ?? match);
	}

	const connect= async () => {
		setLoading(true);
		setSummaryText('');
		setActiveTab('transcription');
		const userid=props.uid;
		const loggedInUserName=props.loggedInUserName;
		//create room
		const roomName=`testroom-${userid}-${getRandomInt(1000,9999)}`;
		const agent_name=`testagent-${props.selectedAgent.id}-${getRandomInt(1000,9999)}`;
		setAgentName(agent_name)

		const participantName=loggedInUserName??'test-user';
		console.log('Room Name:', roomName, 'Participant Name:', participantName);
		await createroom(roomName, participantName);
		//create agent and add to room
		await createtestsession(roomName,props.selectedAgent,agent_name);
		// console.log('Agent', JSON.stringify(props.selectedAgent));
		room.startAudio()
		setIsConnected(true);
		setLoading(false);
	}

	async function createroom(roomName, participantName) {
				const result = await axios.get(`/getLivekitToken/${roomName}/${participantName}`)
				console.log('Livekit token', result.data);
				room.connect(process.env.REACT_APP_LIVEKIT_URL, result.data);
	}

	async function createtestsession(roomName,agent,agent_name) {
		console.log('Creating test session for agent:', agent);
		const instructions = replaceDynamicVariables(testprompt||agent.prompt);
		const firstmessage = replaceDynamicVariables(testFirstMessage||agent.firstmessage);

		const data={
			"user_id": props.uid,
			"agent_id": props.selectedAgent.id,
			"agent_name": agent_name,
			"instructions": instructions,
			"firstmessage": firstmessage,
			"room_name": roomName,
			"voiceprovider": agent.voiceprovider,
			"voicemodel": agent.voicemodel,
			"voiceid": agent.voicevoiceid
			};
		const result = await axios.post(`/start_test_session`, data)
		console.log('Test agent session start result', result.data);
	}

	async function stoptestsession(){
		setLoading(true);
		room.disconnect();
		setSummaryText('');
		const result = await axios.post(`/stop_agent`,{
				"agent_name": agentName
			})

		setIsConnected(false);
		// switch to summary tab when stopping the session
		setActiveTab('summary');
		setLoading(false);
	}

	useEffect(() => {
		setActiveTab('transcription');
		return () => {
			// Clean up the room when the component unmounts
			setActiveTab('transcription');
			setTestPrompt('');
			setTestFirstMessage('');
			setLoading(false);
			if (room.state === 'connected') {
				room.disconnect();
			}
		};
	}, []);

	return (
		<>  <RoomContext.Provider data-lk-theme="default" value={room} >
			<Modal
				show={props.showtestagentmodal}
				onHide={() => {
					stoptestsession();
					props.setShowtestagentmodal(false);
					setActiveTab('transcription');
				}}
				centered
				size="xl"
				backdrop="static" keyboard={false}
				>
				<Modal.Header closeButton={true} >
					<div className="fs-6">Test Agent</div>
				</Modal.Header>
				<Modal.Body className="m-1 p-3">
					<Row>
						<Col xs={12} md={6}>
							<Row>
								<div className="d-flex justify-content-center align-items-center mb-4">
									<img src="/sales_rep.png" alt="Sales Rep" style={{width:200, height:200, objectFit:'contain'}} />
								</div>
							</Row>
								{/* <SimpleVoiceAssistant/> */}
								{/* <MyAudioTrack selectedAgent={props.selectedAgent} /> */}
								
								{/* <RoomAudioRenderer /> */}

								{/* <SimpleVoiceAssistant/> */}
								<Row style={{height: '20vh'}} className="px-4">

									{/* <AudioConference style={{margin:"auto"}}/> */}
									{/* <AgentOnlyVisualizer agentIdentity={`testagent-${props.selectedAgent.id}`} /> */}
									{/* <StartAudioOnce/> */}
									<MyAudioConference  />
									{/* <DebugParticipants/> */}
								</Row>
								<Row className="mt-3 mb-3 px-4">
									<Col xs={12} className="mb-2">
										<div className="fw-bolder">Dynamic Values: </div>
									</Col>
									<Col md={4} className="mb-2">
										<Form.Group controlId="personName">
											{/* <Form.Label>Person Name</Form.Label> */}
											<Form.Control type="text" placeholder="[PERSON_NAME]" value={personName} onChange={e => setPersonName(e.target.value)} />
										</Form.Group>
									</Col>
									<Col md={4} className="mb-2">
										<Form.Group controlId="companyName">
											{/* <Form.Label>Company Name</Form.Label> */}
											<Form.Control type="text" placeholder="[COMPANY_NAME]" value={companyName} onChange={e => setCompanyName(e.target.value)} />
										</Form.Group>
									</Col>
									<Col md={4} className="mb-2">
										<Form.Group controlId="personRole">
											{/* <Form.Label>Person Role</Form.Label> */}
											<Form.Control type="text" placeholder="[PERSON_ROLE]" value={personRole} onChange={e => setPersonRole(e.target.value)} />
										</Form.Group>
									</Col>
								</Row>
								{/* <VideoConference /> */}
								{/* <ConnectionState /> */}
								<Row>
									<div className="controls d-flex justify-content-between align-items-center mb-2" style={{ maxWidth: "700px",bottom:"1rem" }}>
										<div className="d-flex align-items-center">
											<TrackToggle source={Track.Source.Microphone} />
											<span className="ms-0 ms-md-1">Microphone</span>
										</div>
										<PauseButton />
										<Button className='px-md-5 px-3 d-flex align-items-center justify-content-center' variant={isConnected?"danger": "success"} onClick={()=>{isConnected?stoptestsession():connect()}} disabled={loading}>
											{loading ? (
												<>
													<Spinner animation="border" size="sm" role="status" className="me-2" />
													{isConnected ? 'Stopping...' : 'Starting...'}
												</>
											) : (
												(isConnected ? 'Stop' : 'Start')
											)}
										</Button>
									</div>
								</Row>
						</Col>
						<Col xs={12} md={6} className='mt-2' style={{ overflow: "hidden"}}>
							
									<Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="justify-content-start">
										<Tab eventKey="transcription" title="Transcription" />
										<Tab eventKey="prompt" title="Prompt" />
										<Tab eventKey="summary" title="Summary" />
									</Tabs>
								
							
									<ChatBox room={room} summaryText={summaryText} activeTab={activeTab} selectedAgent={props.selectedAgent} testprompt={testprompt} setTestPrompt={setTestPrompt} testFirstMessage={testFirstMessage} setTestFirstMessage={setTestFirstMessage}/>
								
						</Col>
					
					</Row>
				</Modal.Body>
				{/* <Modal.Footer style={{ justifyContent: "flex-start" }}>
					<p className="mx-1">Note : You cannot run campaign for a paused list. Please wait for the List to get completed or Stop the crawl Job to run a campaign on that list</p>
				</Modal.Footer> */}
			</Modal>
			</RoomContext.Provider>
		</>
	)
}

export default TestAgentModal